<template>

<div class="inner" :class="{'is-row': row, 'is-padded': padded, 'is-center': center, 'is-condensed': condensed}">

	<slot></slot>

</div>

</template>

<script>

export default {

	props: ['row', 'condensed', 'padded', 'center']

}

</script>

<style scoped>

.inner {
	display: flex;
	flex-direction: column;
	width: 1200px;
	margin: 0px auto;
	min-height: 100%;
}

.is-tablet .inner {
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
}

.is-mobile .inner {
    width: 100%;
    padding-left: 8px;
    padding-right: 8px;
}

.inner.is-padded {
    padding: 20px 0px;
}

.inner.is-row {
	flex-direction: row;
}

.inner.is-center {
	align-items: center;
}

.inner.is-condensed {
	max-width: 800px;
}

</style>